module.exports = __webpack_public_path__ + "img/close-button.e511707e.svg";